/**
 * „Větší písmo" pro zarizeni (navrh v3, pro starsi lidi). Stejny klic cte
 * i inline skript v index.html, aby se text nezvetsoval az po nacteni.
 */
const STORAGE_KEY = 'sp:pismo'

export function largeText(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'velke'
  } catch {
    return false
  }
}

export function applyLargeText(on: boolean): void {
  try {
    if (on) localStorage.setItem(STORAGE_KEY, 'velke')
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Bez localStorage plati volba jen do zavreni stranky.
  }
  if (on) document.documentElement.dataset['text'] = 'large'
  else delete document.documentElement.dataset['text']
}
